// = Libs =
import {FC, useState} from 'react';

// = Containers & Components =
import {SplitContent} from '@/common/containers/split-content/split-content';
import Container from '@/common/containers/container/container';
import {useHistory, useParams} from 'react-router-dom';
import {CalendarState} from '@/common/components/ui/calendar/calendar';
import {ReportCardModel, useReports} from '@/services/report.service';
import {SideBar} from '@/pages/poll/author-poll/tabs/poll-reports/reports-side-bar';
import ReportCard from '@/pages/poll/author-poll/tabs/poll-reports/report-card/report-card';
import Report from "@/pages/poll/componens/report/report";
import ReportActionPanel from "../componens/report/report-action-panel/report-action-panel";
import Jumbotron from "@/common/components/core/jumbotron/jumbotron";
import {formatReportStatus} from "@/helpers/formatStatus";
import Page from "@/common/containers/page/page";
import {BEFullPollModel, usePollWithReportData} from "@/services/poll.service";

const ReportView: FC = () => {
	const {pollId, orgId} = useParams<{ pollId: string; orgId: string }>();

	const pollData: BEFullPollModel = usePollWithReportData(
		Number(pollId),
		Number(orgId)
	);


	return (
		<Page>
			<Jumbotron
				title={pollData?.title}
				previousPath={`/poll/author/${pollData?.pollId}`}
				previousPage="К опросу"
				label={formatReportStatus(pollData?.report?.status || 'new')?.text}
				labelColor={
					formatReportStatus(pollData?.report?.status || 'new')?.color
				}
			/>
			<Container>
				{pollData?.report?.reportId &&
					<Report reportId={Number(pollData.report.reportId)} disabled/>
				}
			</Container>
		</Page>
	);
};

export default ReportView;
